import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, OnDestroy, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.sass'],
  providers: [{ provide: MatFormFieldControl, useExisting: PhoneNumberComponent }],
})
export class PhoneNumberComponent implements OnDestroy, MatFormFieldControl<string>, ControlValueAccessor {
  @ViewChild('input') input?: HTMLInputElement;

  @Output() dialCode: EventEmitter<string> = new EventEmitter<string>();

  private _telInputObject: any;

  static nextId = 0;

  ng2TelInputOptions: any = {
    separateDialCode: true,
    formatOnDisplay: false,
    initialCountry: 'us',
  };

  tel: null | string = '';

  id = `phone-number-input-${PhoneNumberComponent.nextId++}`;

  stateChanges = new Subject<void>();

  focused = false;

  touched = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
  onChange = (value: any) => {};

  onTouched = () => {};

  get empty() {
    return !this.tel;
  }

  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get errorState(): boolean {
    return !this.tel && this.touched;
  }

  @Input() readonly: boolean | undefined;

  @Input()
  get value(): string | null {
    return this.tel;
  }

  set value(tel: string | null) {
    this.tel = tel;
    this.stateChanges.next();
  }

  @Input()
  get placeholder(): string {
    return this._placeholder;
  }

  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }

  private _placeholder: string = '';

  @Input()
  get required(): boolean {
    return this._required;
  }

  set required(value: BooleanInput) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  private _required = false;

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: BooleanInput) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  private _disabled = false;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  setDescribedByIds() {}

  onContainerClick() {
    this.dialCode.emit(this._telInputObject.getSelectedCountryData().dialCode);
  }

  writeValue(tel: string | null): void {
    this.value = tel;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  telInputObject(obj: any) {
    this._telInputObject = obj;
  }

  onTelInput() {
    this.onChange(this._telInputObject.getNumber());
    this.stateChanges.next();
  }
}
